import { Upload, Loader2 } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface FileUploadButtonProps {
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isUploading: boolean;
  disabled: boolean;
  accept: string;
}

export const FileUploadButton = ({ 
  onFileChange, 
  isUploading, 
  disabled,
  accept 
}: FileUploadButtonProps) => {
  return (
    <div className="flex items-center gap-2">
      <Input
        type="file"
        onChange={onFileChange}
        className="hidden"
        id="file-upload"
        multiple
        accept={accept}
        disabled={disabled}
      />
      <Label
        htmlFor="file-upload"
        className={cn(
          "flex items-center gap-2 cursor-pointer px-4 py-2 border rounded-md transition-colors",
          disabled 
            ? "opacity-50 cursor-not-allowed bg-muted border-muted-foreground/20" 
            : "hover:bg-accent"
        )}
      >
        {isUploading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Upload className="h-4 w-4" />
        )}
        {isUploading ? 'Uploading...' : 'Add Files'}
      </Label>
    </div>
  );
};